const addDivisionCodeMigration = (state) => ({
  selectedFilters: {
    ...state.selectedFilters,
    divisions: [],
  },
  appliedFilters: {
    ...state.appliedFilters,
    divisions: [],
  },
})

const addModifiedFieldToExportStatusMigration = (state) => ({
  selectedFilters: {
    ...state.selectedFilters,
    exportStatus: {
      ...state.selectedFilters.exportStatus,
      modified: false,
    },
  },
  appliedFilters: {
    ...state.appliedFilters,
    exportStatus: {
      ...state.appliedFilters.exportStatus,
      modified: false,
    },
  },
})

const addFilterByCreatedByRetailer = (state) => ({
  selectedFilters: {
    ...state.selectedFilters,
    createdByRetailer: false,
  },
  appliedFilters: {
    ...state.appliedFilters,
    createdByRetailer: false,
  },
})

// Moves the legacy standalone `onlyUnassignedOrdersFilter` flag into the
// standard selected/applied filters as the new "Connection Status" filters.
const addConnectionStatusFilters = (state) => {
  const {
    onlyUnassignedOrdersFilter,
    onlyHubUnassignedOrdersFilter: _onlyHubUnassignedOrdersFilter,
    ...rest
  } = state
  const isUnassigned = Boolean(onlyUnassignedOrdersFilter)
  return {
    ...rest,
    selectedFilters: {
      ...rest.selectedFilters,
      isUnassigned,
      pendingConnection: false,
      isConnected: false,
    },
    appliedFilters: {
      ...rest.appliedFilters,
      isUnassigned,
      pendingConnection: false,
      isConnected: false,
    },
  }
}

export const migrations = [
  addDivisionCodeMigration,
  addModifiedFieldToExportStatusMigration,
  addFilterByCreatedByRetailer,
  addConnectionStatusFilters,
]
